import * as Website from '../../Config/Website.js';
import * as ProductsHover from '../../Modules/ProductsHover.js';
import FvSlider from '../../Modules/FvSlider.js';


const preinit = () => {

}

const init = () => {
  ProductsHover.init();
  FvSlider();
}

const resize = () => {
}

const resizeW = () => {
}

const scroll = () => {

}

const load = () => {
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}